import React, { useState } from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';
import { HiAcademicCap, HiCheck } from 'react-icons/hi2';

function StudentGroupSelectionModal({
    isOpen,
    onClose,
    groups = [],
    selectedGroups = [],
    onGroupSelect
}) {
    const [localSelectedGroups, setLocalSelectedGroups] = useState(selectedGroups);

    const handleGroupToggle = (groupName) => {
        setLocalSelectedGroups(prev => {
            if (prev.includes(groupName)) {
                return prev.filter(g => g !== groupName);
            } else {
                return [groupName]; // Only allow one group selection for students
            }
        });
    };

    const handleConfirm = () => {
        onGroupSelect(localSelectedGroups);
        onClose();
    };

    const handleCancel = () => {
        setLocalSelectedGroups(selectedGroups); // Reset to original selection
        onClose();
    };

    // Ensure groups is an array and filter out empty values
    const groupOptions = Array.isArray(groups) ? groups.filter(g => g) : [];

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleCancel}
            title="Select Your Group"
            className="max-w-lg"
        >
            <div className="space-y-4">
                <div className="flex items-center gap-2 text-gray-600 mb-4">
                    <HiAcademicCap className="h-5 w-5" />
                    <span className="text-sm">Choose your group to see your schedule</span>
                </div>

                <div className="max-h-64 overflow-y-auto space-y-2">
                    {groupOptions.length > 0 ? (
                        groupOptions.map((group) => {
                            const groupName = typeof group === 'string' ? group : (group?.name || group?.group_code || 'Unknown');
                            const groupKey = typeof group === 'string' ? group : (group?.id || group?.name || group?.group_code || 'Unknown');
                            const isSelected = localSelectedGroups.includes(groupName);

                            return (
                                <button
                                    key={groupKey}
                                    onClick={() => handleGroupToggle(groupName)}
                                    className={`w-full text-left p-3 rounded-lg border-2 transition-all ${isSelected
                                        ? 'border-blue-500 bg-blue-50 text-blue-900'
                                        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                                        }`}
                                >
                                    <div className="flex items-center justify-between">
                                        <span className="font-medium">{groupName}</span>
                                        {isSelected && (
                                            <HiCheck className="h-5 w-5 text-blue-600" />
                                        )}
                                    </div>
                                </button>
                            );
                        })
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            <HiAcademicCap className="h-12 w-12 mx-auto mb-2 text-gray-300" />
                            <p>No groups available</p>
                        </div>
                    )}
                </div>

                <div className="flex justify-end gap-3 pt-4 border-t">
                    {/* <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                    </Button> */}
                    <Button
                        variant="primary"
                        onClick={handleConfirm}
                        disabled={localSelectedGroups.length === 0}
                    >
                        Select Group
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default StudentGroupSelectionModal;
